import { MijnRoute } from '../../mijn-navigatie.model';

export const INVESTMENT_PLANNER: MijnRoute = {
    path: ':id/planner',
    navigationEvent: 'toPlanner',
    regex: /^\/beleggen\/[^/]+\/planner$/,
    webcomponent: 'mijn-beleggen-portfolio-webcomponent',
    internalPath: ':id/planner'
};
